export const exportMenuItems = [
  {
    label: "SHA1",
    value: "include_sha1",
    disabled: true
  },
  {
    label: "SHA256",
    value: "include_sha256"
  },
  {
    label: "MD5",
    value: "include_md5"
  },
  {
    label: "Time",
    value: "include_time"
  },
  {
    label: "Threat",
    value: "include_threat"
  },
  {
    label: "Name",
    value: "include_name"
  },
  {
    label: "Size",
    value: "include_size"
  },
  {
    label: "Files",
    value: "include_files"
  },
  {
    label: "Format",
    value: "include_format"
  }
];

export const MENU_STYLE = {
  maxHeight: "300px",
  overflow: "auto"
} as const;
